import axios, { AxiosResponse } from "axios";
import { ISettings } from "../types/ISettings";
import { IReceiptData } from "../types/IReceiptData";
import { ITelephone } from "../types/ITelephone";
import { apiUrl } from "../EposConfig";
import { ISnookerTable } from "../types/ISnookerTable";
import { ISnookerAction } from "../types/ISnookerAction";

const baseConfig = {
  baseURL: apiUrl,
  timeout: 10000,
  headers: {
    "Content-Type": "application/json",
    Authorization: "Bearer ",
  },
  validateStatus: () => true,
};

export const getSettings = (token: string): Promise<ISettings | void> => {
  const config = baseConfig;
  config.headers.Authorization = "Bearer " + token;
  return axios
    .get("Settings", config)
    .then((response: AxiosResponse<ISettings>) => {
      return response.data;
    })
    .catch(handleError);
};

export const getSnookerTables = (
  token: string
): Promise<ISnookerTable[] | void> => {
  const config = baseConfig;
  config.headers.Authorization = "Bearer " + token;
  return axios
    .get("Snooker/Tables", config)
    .then((response: AxiosResponse<ISnookerTable[]>) => {
      return response.data;
    })
    .catch(handleError);
};

export const startSnookerTable = (
  uuid: string,
  token: string,
  dt: Date
): Promise<boolean | void> => {
  const config = baseConfig;
  config.headers.Authorization = "Bearer " + token;

  const action: ISnookerAction = {
    uuid: uuid,
    action: "start",
    data: dt.toJSON(),
  };
  return axios
    .post("Snooker/Start", action, config)
    .then((response: AxiosResponse<boolean>) => {
      if (response.status === 200) {
        return response.data;
      }
      return false;
    })
    .catch(handleError);
};

export const advancePayment = (
  uuid: string,
  token: string,
  paid: string
): Promise<boolean | void> => {
  const config = baseConfig;
  config.headers.Authorization = "Bearer " + token;

  const action: ISnookerAction = {
    uuid: uuid,
    action: "advancePayment",
    data: paid,
  };
  return axios
    .post("Snooker/AdvancePay", action, config)
    .then((response: AxiosResponse<boolean>) => {
      if (response.status === 200) {
        return response.data;
      }
      return false;
    })
    .catch(handleError);
};

export const tableReminder = (
  uuid: string,
  token: string,
  minutes: string
): Promise<boolean | void> => {
  const config = baseConfig;
  config.headers.Authorization = "Bearer " + token;

  const action: ISnookerAction = {
    uuid: uuid,
    action: "ReminderInMinutes",
    data: minutes,
  };
  return axios
    .post("Snooker/ReminderInMinutes", action, config)
    .then((response: AxiosResponse<boolean>) => {
      if (response.status === 200) {
        return response.data;
      }
      return false;
    })
    .catch(handleError);
};

export const cancelTable = (
  uuid: string,
  token: string
): Promise<boolean | void> => {
  const config = baseConfig;
  config.headers.Authorization = "Bearer " + token;

  const action: ISnookerAction = {
    uuid: uuid,
    action: "CancelTable",
    data: "",
  };
  return axios
    .post("Snooker/CancelTable", action, config)
    .then((response: AxiosResponse<boolean>) => {
      if (response.status === 200) {
        return response.data;
      }
      return false;
    })
    .catch(handleError);
};

export const saveReceiptRows = (
  tableUuid: string,
  token: string,
  data: string
): Promise<boolean | void> => {
  const config = baseConfig;
  config.headers.Authorization = "Bearer " + token;

  const action: ISnookerAction = {
    uuid: tableUuid,
    action: "SaveReceiptToTable",
    data: data,
  };
  return axios
    .post("Snooker/ReceiptRows", action, config)
    .then((response: AxiosResponse<boolean>) => {
      if (response.status === 200) {
        return response.data;
      }
      return false;
    })
    .catch(handleError);
};

export const getTelephoneData = (
  token: string
): Promise<ITelephone[] | void> => {
  const config = baseConfig;
  config.headers.Authorization = "Bearer " + token;
  return axios
    .get("Telephone/Telephone", config)
    .then((response: AxiosResponse<ITelephone[]>) => {
      return response.data;
    })
    .catch(handleError);
};

export const createOrder = (
  data: IReceiptData,
  token: string
): Promise<boolean | void> => {
  const config = baseConfig;
  config.headers.Authorization = "Bearer " + token;
  return axios
    .post("Snooker/ReceiptAdd", data, config)
    .then((response: AxiosResponse<boolean>) => {
      if (response.status === 200) {
        return response.data;
      }
      return false;
    })
    .catch(handleError);
};

function handleError(error: any) {
  console.log("api error @ " + new Date());
  console.log(error);
  console.log(error.response);

  if (error.response) {
    console.log(error.response.data);
    console.log(error.response.status);
    console.log(error.response.headers);
  } else if (error.request) {
    console.log(error.request);
  } else {
    console.log("Error", error.message);
  }
}
